// extracted by mini-css-extract-plugin
export default {"Box":"Controls-module__Box--VPTk1","IconButton":"Controls-module__IconButton--_wVfj"};